import { useState } from "react";
import "./Calculator.css";
const Calculator = () => {
  const [input, setInput] = useState("");
  const [result, setResult] = useState("");

  const handleButtonClick = (value) => {
    setInput((prevInput) => {
      const newInput = prevInput + value;
      // console.log(newInput, "newInput");
      return newInput;
    });
  };

  const handleClear = () => {
    setInput("");
    setResult("");
  };

  const handleCalculate = () => {
    try {
      // eslint-disable-next-line no-eval
      const calculation = eval(input);
      setResult(calculation);
    } catch (error) {
      setResult("Error");
    }
  };
  return (
    <div className="container">
      <div className="calculator">
        <div className="holdcal">
          <div className="display">
            <input type="text" value={input} readOnly />
            <div className="result">{result}</div>
          </div>
          <div className="buttons">
            <button className="clear" onClick={handleClear}>
              C
            </button>
            <button onClick={() => handleButtonClick("1")}>1</button>
            <button onClick={() => handleButtonClick("2")}>2</button>
            <button onClick={() => handleButtonClick("3")}>3</button>
            <button onClick={() => handleButtonClick("+")}>+</button>
            <button onClick={() => handleButtonClick("4")}>4</button>
            <button onClick={() => handleButtonClick("5")}>5</button>
            <button onClick={() => handleButtonClick("6")}>6</button>
            <button onClick={() => handleButtonClick("-")}>-</button>
            <button onClick={() => handleButtonClick("7")}>7</button>
            <button onClick={() => handleButtonClick("8")}>8</button>
            <button onClick={() => handleButtonClick("9")}>9</button>
            <button onClick={() => handleButtonClick("*")}>*</button>
            <button onClick={() => handleButtonClick(".")}>.</button>
            <button onClick={() => handleButtonClick("(")}>(</button>
            <button onClick={() => handleButtonClick(")")}>)</button>
            <button onClick={() => handleButtonClick("0")}>0</button>
            <button onClick={() => handleButtonClick("/")}>/</button>
            <button className="result-Btn" onClick={handleCalculate}>
              =
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Calculator;
